import React from 'react';
import reportLocales from 'globals/locales/report';
import { observer } from 'mobx-react';
import { useReportContext } from 'contexts/report/ReportContext';
import { isSuccessState } from 'globals/utils';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import CustomScroll from 'react-custom-scroll';
import { Box } from '@material-ui/core';
import FsNoEventsFeedIcon from 'ui-elements/icons/FsNoEventsFeed';
import {
  HeaderBox,
  ContainerBox,
  Title,
  TitleCount,
  AbsoluteBox,
  NoEventsFeedTitle,
  NoEventsFeedSubTitle,
  CenterBox,
  AbsoluteNoEventsFeedBox,
} from './EventsFeed.style-elements';
import SingleEventsFeedItem from './SingleEventsFeedItem';
import 'react-custom-scroll/dist/customScroll.css';
import 'assets/styles/fs-custom-scroll.css';

// Locales
const { title, noTitle, noSubTitle } = reportLocales.eventsFeed;

const EventsFeed: React.FC = () => {
  const {
    report: {
      eventsFeed: { status, eventsFeedList },
    },
  } = useReportContext();
  const events = eventsFeedList();

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
        withMargin={false}
      />
    );

  return (
    <ContainerBox data-test="events-feed-component">
      <HeaderBox>
        <Title>{title}</Title>
        <TitleCount>{`(${events.length})`}</TitleCount>
      </HeaderBox>
      {events.length ? (
        <AbsoluteBox>
          <CustomScroll heightRelativeToParent="100%">
            {events.map(({ id, ...otherProps }) => (
              <SingleEventsFeedItem
                {...otherProps}
                key={id}
                id={id}
                data-test="single-events-feed"
              />
            ))}
          </CustomScroll>
        </AbsoluteBox>
      ) : (
        <AbsoluteNoEventsFeedBox>
          <CenterBox>
            <Box maxWidth={160}>
              <CenterBox>
                <FsNoEventsFeedIcon />
              </CenterBox>
              <NoEventsFeedTitle>{noTitle}</NoEventsFeedTitle>
              <NoEventsFeedSubTitle>{noSubTitle}</NoEventsFeedSubTitle>
            </Box>
          </CenterBox>
        </AbsoluteNoEventsFeedBox>
      )}
    </ContainerBox>
  );
};

export default observer(EventsFeed);
